import { useEffect, useRef } from "react";

function useIntereval(callback: Function, delay?: number | null): NodeJS.Timer {
  const id = useRef<NodeJS.Timer>();
  const savedCallback = useRef<Function>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      if (typeof savedCallback.current === "function") {
        savedCallback.current();
      }
    };

    if (typeof delay !== "undefined" && delay !== null) {
      id.current = setInterval(tick, delay);
      return () => clearInterval(id.current);
    }
  }, [delay]);

  return id.current!;
}

export default useIntereval;
